import { combineReducers } from 'redux';

import dateTime from 'react-redux-app/lib/modules/dateTime/reducer';
import exception from 'react-redux-app/lib/modules/exception/reducer';
import globalError from 'react-redux-app/lib/modules/globalError/reducer';
import grid from 'react-redux-app/lib/modules/grid/reducer';
import i18n from 'react-redux-app/lib/modules/i18n/reducer';
import modals from 'react-redux-app/lib/modules/modal/reducer';

import chart from '../../core/chart/reducer';
import auth from '../../auth/reducer';
import affiliateTools from '../../affiliateTools/reducer';
import affiliateProgram from '../../affiliateProgram/reducer';
import affiliatedWebmasters from '../../affiliatedWebmasters/reducer';
import affiliatedUsers from '../../affiliatedUsers/reducer';
import balanceAdjustments from '../../balanceAdjustments/reducer';
import ui from '../../ui/reducer';
import init from '../../init/reducer';
import webmaster from '../../webmaster/reducer';
import campaign from '../../campaign/reducer';
import campaignStats from '../../campaignStats/reducer';
import lossesAndCompensations from '../../lossesAndCompensations/reducer';
import payout from '../../payout/reducer';
import revenue from '../../revenue/reducer';
import fiscalNumber from '../../fiscalNumber/reducer';
import wire from '../../wire/reducer';
import xcard from '../../xcard/reducer';
import payoutSettings from '../../payoutSettings/reducer';
import site from '../../site/reducer';
import siteAlias from '../../siteAlias/reducer';
import siteArticle from '../../siteArticle/reducer';
import siteGoogleAnalytics from '../../siteGoogleAnalytics/reducer';
import siteGoogleTool from '../../siteGoogleTool/reducer';
import siteTemplateConfiguration from '../../siteTemplateConfiguration/reducer';
import siteFavicon from '../../siteFavicon/reducer';
import siteSeo from '../../siteSeo/reducer';
import siteTexts from '../../siteTexts/reducer';
import banner from '../../banner/reducer';
import siteBuilder from '../../siteBuilder/reducer';
import siteStaticPages from '../../siteStaticPages/reducer';
import siteFooterLinks from '../../siteFooterLinks/reducer';
import certificate from '../../certificate/reducer';
import lastUpdateTime from '../../core/lastUpdateTime/reducer';
import socialNetworksSettings from '../../socialNetworksSettings/reducer';
import contactUs from '../../contactUs/reducer';
import postbackSettings from '../../postbackSettings/reducer';

export default combineReducers({
  // vendor
  dateTime,
  exception,
  globalError,
  grid,
  i18n,
  modals,

  // rivcash
  contactUs,
  chart,
  auth,
  affiliateTools,
  affiliateProgram,
  affiliatedWebmasters,
  affiliatedUsers,
  balanceAdjustments,
  init,
  webmaster,
  fiscalNumber,
  wire,
  xcard,
  payoutSettings,
  ui,
  campaign,
  campaignStats,
  lossesAndCompensations,
  payout,
  revenue,
  site,
  siteAlias,
  siteArticle,
  siteFavicon,
  siteTemplateConfiguration,
  siteSeo,
  siteBuilder,
  siteGoogleAnalytics,
  siteGoogleTool,
  siteTexts,
  siteStaticPages,
  siteFooterLinks,
  banner,
  certificate,
  lastUpdateTime,
  socialNetworksSettings,
  postbackSettings,
});
